import Tile from "./Tile";
import TileHeader from "./TileHeader";
import TileBody from "./TileBody";
import TileTitle from "./TileTitle";

export { TileHeader, TileBody, TileTitle };

export default Tile;
